<template>
  <v-card
    elevation='2'
    :color="guestTypologyBgColor"
  >
    <v-list-item three-line>
      <v-list-item-content>
        <div class="overline">
          {{ $t('guest.attributes.typologies.' + guest.typology.toLowerCase()) }}
        </div>
        <v-list-item-title class="headline mb-1">
          {{ guest.first_name + ' ' + guest.last_name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ guest.email }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-icon>
        <v-icon large>
          mdi-{{ guestTypologyIcon }}
        </v-icon>
      </v-list-item-icon>
    </v-list-item>

    <v-divider class="mt-3"/>

    <v-card-text>
      <v-row>
        <v-col class='py-1'>
          {{ $t('guest.attributes.birthdate') }}<br>
          <strong>{{ formattedDate(guest.birthdate) }}</strong>
        </v-col>
        <v-col class='py-1'>
          {{ $t('guest.attributes.sex') }}<br>
          <strong>{{ guestGender }}</strong>
        </v-col>
      </v-row>
      <v-row v-if="isRoomChief || isSingle">
        <v-col class='py-1'>
          {{ $t('guest.attributes.phone') }}<br>
          <strong>{{ `${guest.phone_prefix} ${guest.phone}` }}</strong>
        </v-col>
        <v-col class='py-1'>
          {{ $t('guest.attributes.email') }}<br>
          <strong>{{ guest.email }}</strong>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import { guestMixin } from "../../mixins/guest_mixin"
  import { utilityMixin } from '../../mixins/utility_mixin'

  export default {
    mixins: [
      guestMixin,
      utilityMixin,
    ],
    props: {
      guest: {
        type: Object,
        required: true,
      }
    },
    computed: {
      ...mapState('application', ['current_organization']),
      guestTypologyBgColor() {
        return this.isRoomChief ? 'grey lighten-3' : 'grey lighten-5'
      },
    }
  }
</script>
